import { Typography, Chip, Box, IconButton } from '@mui/material';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import CloseIcon from '@mui/icons-material/Close';

export default function MapCard({ place, onClose }) {
  if (!place) return null;

  return (
    <Box
      sx={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        zIndex: 2000,
        width: '90%',
        maxWidth: 380,
        maxHeight: '80vh',
        overflow: 'hidden',
        borderRadius: 2,
        boxShadow: 3,
        bgcolor: 'background.paper',
      }}
    >
      {place.image && (
        <Box sx={{ position: 'relative', height: 200, flexShrink: 0 }}>
          <img
            src={place.image}
            alt={place.title}
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </Box>
      )}

      <Box
        sx={{
          p: 2,
          maxHeight: place.image ? 'calc(80vh - 200px)' : '80vh',
          overflowY: 'auto',
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1, mb: 1 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, fontSize: '1.1rem', flex: 1, minWidth: 0 }}>
            {place.title}
          </Typography>
          <IconButton
            onClick={onClose}
            aria-label="Cerrar"
            size="small"
            sx={{
              flexShrink: 0,
              bgcolor: 'action.hover',
              '&:hover': { bgcolor: 'action.selected' },
            }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>
        <Chip
          label={place.category}
          size="small"
          sx={{ mb: 1.5, bgcolor: 'primary.light', color: 'primary.dark', fontWeight: 500 }}
        />
        <Typography
          variant="body2"
          sx={{
            color: 'text.secondary',
            lineHeight: 1.5,
            mb: 1.5,
            wordBreak: 'break-word',
            whiteSpace: 'pre-wrap',
          }}
        >
          {(place.description && place.description.length > 120 ? place.description.slice(0, 120).trim() + '\u2026' : (place.description || 'Sin descripción.'))}
        </Typography>
        <Box sx={{ mt: 1 }}>
          {place.address && (
            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mb: 0.5 }}>
              <LocationOnIcon sx={{ color: 'text.secondary', fontSize: 18, mt: 0.2 }} />
              <Typography variant="body2" color="text.secondary" sx={{ wordBreak: 'break-word' }}>
                {place.address}
              </Typography>
            </Box>
          )}
          {place.phone && (
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <PhoneIcon sx={{ color: 'text.secondary', fontSize: 18 }} />
              <Typography variant="body2" color="text.secondary">
                {place.phone}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
}
